import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";

/** Whether views should show tasks: the tenant uses tasks and the user may read them. */
export function useTasksEnabled(): boolean {
	const { tenantConfig } = useTenantCustomizations();
	const hasPermission = useHasPermission();
	return (tenantConfig.tasks.enabled ?? false) && hasPermission(Permissions.Tasks.READ);
}
